import { Injectable } from '@angular/core';
import { EQueryFilterDefinitions } from '../../e-queries/e-query-filter-definitions';
import { FilterFieldValue } from '../../covance-filter';

@Injectable()
export class AdminEQueryFilterDefinitionsResolver {
    constructor(private readonly eQueryFilterDefinitions: EQueryFilterDefinitions) {
    }

    public createAdminFilterItems(): FilterFieldValue[] {
        return [
            this.eQueryFilterDefinitions.eQueryId(),
            this.eQueryFilterDefinitions.age(),
            this.eQueryFilterDefinitions.visitCollectionDate(),
            this.eQueryFilterDefinitions.status()
        ];
    }

    public createAdminHideUnhideFilterItems(): FilterFieldValue[] {
        return [
            this.eQueryFilterDefinitions.eQueryId()
        ];
    }
}
